// Niveis de acesso ao quadro (contrato M1 — GET/PUT/DELETE /boards/:id/access,
// POST /workspaces com members). Compartilhado entre InviteMembersModal e
// WorkspaceCreateModal pra manter rotulos e valores consistentes.
export const ACCESS_LEVELS = [
  { value: 'viewer', label: 'Leitor' },
  { value: 'contributor', label: 'Colaborador' },
  { value: 'editor', label: 'Editor' },
  { value: 'owner', label: 'Dono do quadro' },
  { value: 'deny', label: 'Sem acesso' },
];

// Subconjunto usado ao conceder acesso (criar área com pessoas, adicionar
// pessoa nova ao quadro) — 'deny' só faz sentido como exceção sobre alguém
// que já teria acesso por herança, não ao conceder de novo.
export const GRANT_LEVELS = ACCESS_LEVELS.filter((l) => l.value !== 'deny');

// source de GET /boards/:id/access -> rótulo de origem exibido na lista.
export const ACCESS_SOURCE_LABEL = {
  role: 'pelo grupo',
  workspace: 'pela área',
  board: 'exceção neste quadro',
};

// Nível padrão ao conceder acesso sem escolha explícita prévia. 'editor' pra
// manter o comportamento de hoje do sistema antigo (convidar pro quadro
// sempre dava upsertBoardMember(..., 'editor', ...)) — decisão do dono em
// 2026-09-13, ver mensagem do coordenador.
export const DEFAULT_GRANT_LEVEL = 'editor';
